const NAME = "MODULES_AND_MENUS";

export default NAME;
